import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VRow,{staticClass:"mt-3"},_vm._l((_vm.diagnosticStats.capabilities),function(capability){return _c(VCol,{key:capability.capability_id,attrs:{"cols":"6"}},[_c('player-diagnostic-group-widget',{attrs:{"variables":_vm.diagnosticStats.variables,"capability":capability}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }